<template>
  <b-card no-body>
    <b-card-body class="d-flex flex-column justify-content-center align-items-center">
      <div
        v-if="statisticTitle"
        class="font-medium-4"
      >
        {{ statisticTitle }}
      </div>
      <div class="font-large-2 font-weight-bold">
        {{ statistic.toLocaleString() }}
        <span
          v-if="statisticIcon"
          v-b-tooltip.hover
          class="ml-0 font-small-3"
        >
          {{ statisticNegativeSign ? statisticNegativeSign: '' }}{{ statisticSubTitle.toLocaleString() }}
          <feather-icon
            :class="statisticIconColor ? statisticIconColor: ''"
            :icon="statisticIcon"
            size="16"
          />
        </span>
      </div>
      <div
        v-if="loggedInUsersTotal"
        class="font-small-3"
      >
        ( Logged In Users Total: {{ loggedInUsersTotal.toLocaleString() }} )
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import {
    BCard, BCardBody, BAvatar, VBTooltip,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
    components: {
        BCard,
        BCardBody,
        BAvatar,
    },
    directives: {
        Ripple,
        'b-tooltip': VBTooltip,
    },
    props: {
        icon: {
            type: String,
            required: true,
        },
        statistic: {
            type: [Number],
            required: true,
        },
        statisticTitle: {
            type: [String],
            default: '',
        },
        statisticSubTitle: {
            type: [Number, String],
            default: 0,
        },
        statisticNegativeSign: {
            type: [String],
            default: '',
        },
        statisticIcon: {
            type: [String],
            default: '',
        },
        statisticIconColor: {
            type: [String],
            default: '',
        },
        color: {
            type: String,
            default: 'primary',
        },
        loggedInUsersTotal: {
            type: [Number],
            default: 0,
        },
    },
}
</script>
